export const Earn = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M17.032 12.467a.046.046 0 11-.065.065.046.046 0 010-.065.047.047 0 01.065 0'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M14.662 7.495A3.55 3.55 0 0015 6a3.5 3.5 0 10-7 0c0 .62.175 1.195.459 1.7m6.203-.205c-.045.003-.09.005-.136.005H10c-.533 0-1.05.07-1.541.2m6.203-.205c.38-.026.745-.163 1.051-.394A2.955 2.955 0 0117.5 6.5h1v2.554a5.984 5.984 0 011.626 2.381H21a1 1 0 011 1V15.5a1 1 0 01-1 1h-1.311a6.035 6.035 0 01-2.189 2.191V20.5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H10v.868a1 1 0 01-1 1H7a1 1 0 01-1-1v-2.405A5.978 5.978 0 014 13.5a6.002 6.002 0 014.459-5.8m.003.006L8.459 7.7m-6.171 2.8a1.57 1.57 0 00-.788 1.358c0 .871.706 1.577 1.577 1.577H4'
        ></path>
      </svg>
    </span>
  );
};
